// Check if the locale is valid and normalize it to the format used by the UI Kit

export const normalizeLocale = (locale?: string) => {
    const isValidLocale = locale && /^[a-z]{2}([-_][A-Z]{2})?$/.exec(locale);
    return isValidLocale ? locale?.replace(/_/g, "-") : undefined;
};

export const sortBy = (array: any[], x: string, trim = true) => {
    return array.sort((a, b) => {
        // Extract property values

        const props = x.split(".");
        const [propertyX, propertyY] = props.length === 2 ? props : [x, null];

        let aValue = propertyY ? a[propertyX][propertyY] : a[propertyX];
        let bValue = propertyY ? b[propertyX][propertyY] : b[propertyX];

        if (!aValue) {
            // Change this values if you want to put `null` values at the end of the array
            return 1;
        }

        if (!bValue) {
            // Change this values if you want to put `null` values at the end of the array
            return -1;
        }

        // Apply trim if specified
        if (trim) {
            aValue = aValue?.trim();
            bValue = bValue?.trim();
        }

        // Perform locale comparison
        return aValue.localeCompare(bValue);
    });
};
